export default [
  {
    path: "/pdf/rxdetails/businesses/:businessId/users/:userId/prescriptions/:businessPrescriptionId/generatedby/:generatedByUserId",
    props: true,
    component: () => import("@/views/pdf/RxDetails.vue"),
    meta: {
      hideNav: true,
    },
  },
  {
    path: "/pdf/invoice/businesses/:businessId/users/:userId/charge/:chargeId",
    props: true,
    component: () => import("@/views/pdf/Invoice.vue"),
    meta: {
      hideNav: true,
    },
  },
];
